import {
  CorporatePermissions,
  type CorporatePermissionsKey,
} from '@hapana/shared/schemas/users/enums/corporate-permissions'
import { usePermissions } from '_stores/permissions.store'

const BRAND_PERMISSION_KEYS = Object.keys(CorporatePermissions) as CorporatePermissionsKey[]

const BRAND_HOME_PATHS = ['/', '/c']

const BRAND_REPORTS_SECTIONS = ['/c/reports', '/c/help-docs', '/c/updates']

export const isBrandReportsPath = (path: string): boolean =>
  BRAND_HOME_PATHS.includes(path) ||
  BRAND_REPORTS_SECTIONS.some((section) => path === section || path.startsWith(`${section}/`))

export interface BrandReportsAccess {
  hasBrandControls: boolean
  hasBrandReportsAccess: boolean
}

export const useBrandReportsAccess = (): BrandReportsAccess => {
  const { hasPermission } = usePermissions()
  const hasBrandControls = hasPermission('read_controls') || hasPermission('write_controls')
  const hasBrandReportsAccess =
    !hasBrandControls && BRAND_PERMISSION_KEYS.some((permission) => hasPermission(permission))

  return { hasBrandControls, hasBrandReportsAccess }
}
